import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from '../../COLORS'

export const useStyles = makeStyles(() => ({
  ekomBox: {
    background: 'white',
    padding: 20,
    marginBottom: 25
  },
  ekomTitle: {
    color: COLORS.RED,
    margin: '0 0 20px 0'
  },
  btnItem: {
    color: 'white!important',
    margin: '0 10px 0 0',
    '&:hover': {
      color: 'white!important',
    }
  },
  linkItem: {
    color: `${COLORS.RED}!important`,
    display:"block",
    '&::first-letter': {
      textTransform: 'uppercase',
    },
  },
  linkTab: {
    display: 'block',
    width: 138,
    margin: '0 10px'
  },
  linkTabText: {
    textTransform: 'none'
  },
  listWrap: {
    marginTop: 35
  }
}))
